import { z } from "zod";
import { FieldValue as ClientFieldValue } from "firebase/firestore";
import { FieldValue as ServerFieldValue } from "@google-cloud/firestore";
import { FieldValue as AdminFieldValue } from "firebase-admin/firestore";
const FirestoreTimestampSchema = z.object({
  seconds: z.number().int().describe("\uD0C0\uC784\uC2A4\uD0EC\uD504\uC758 \uCD08 \uBD80\uBD84"),
  nanoseconds: z.number().int().gte(0).lt(1e9).describe("\uD0C0\uC784\uC2A4\uD0EC\uD504\uC758 \uB098\uB178\uCD08 \uBD80\uBD84 (0-999,999,999)"),
  toDate: z.function().args().returns(z.date()).describe("Date \uAC1D\uCCB4\uB85C \uBCC0\uD658\uD558\uB294 toDate \uBA54\uC11C\uB4DC"),
  toMillis: z.function().args().returns(z.number()),
  valueOf: z.function().args().returns(z.string())
});
const FirestoreFieldValueSchema = z.union([
  // 클라이언트 FieldValue (firebase/firestore)
  z.custom((data) => {
    return typeof ClientFieldValue !== "undefined" && data instanceof ClientFieldValue;
  }),
  // 서버 FieldValue (firebase-admin)
  z.custom((data) => {
    return typeof ServerFieldValue !== "undefined" && data instanceof ServerFieldValue;
  }),
  z.custom((data) => {
    return typeof AdminFieldValue !== "undefined" && data instanceof AdminFieldValue;
  })
]);
const FirestoreTimestampLooseSchema = z.union([
  FirestoreFieldValueSchema,
  FirestoreTimestampSchema
]);
export {
  FirestoreFieldValueSchema,
  FirestoreTimestampLooseSchema,
  FirestoreTimestampSchema
};
//# sourceMappingURL=firestore.js.map